import { render } from "./ArchivedPeople.vue?vue&type=template&id=79890816&scoped=true"
import script from "./ArchivedPeople.vue?vue&type=script&lang=js"
export * from "./ArchivedPeople.vue?vue&type=script&lang=js"

import "./ArchivedPeople.vue?vue&type=style&index=0&id=79890816&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79890816"]])

export default __exports__